export default "__VITE_ASSET__BcslgYb8__"